<!--  -->
<template>
    <div class="business-content-main outconfirm-content" v-loading="hLoading || saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div>
            <div class="search-ctn" style="min-height: 0">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                    <el-button v-if="permission.applyPayment" size="small" type="warning" icon="el-icon-receiving" class="search-btn" @click="batchComfirms()">{{
                        permission.applyPayment
                    }}</el-button>
                    <el-button
                        v-if="permission.buildAccount"
                        size="small"
                        type="primary"
                        icon="el-icon-document-add"
                        class="search-btn"
                        @click="showBuildAccount(false)"
                        >{{ permission.buildAccount }}</el-button
                    >
                    <el-button v-if="permission.combineAccount" size="small" type="primary" icon="el-icon-s-finance" class="search-btn" @click="combineComfirms()">{{
                        permission.combineAccount
                    }}</el-button>
                    <el-button
                        size="small"
                        icon="el-icon-document-copy"
                        class="search-btn btn-primary"
                        @click="buildAccountRecords()"
                        v-if="permission.buildAccountRecords"
                        >{{ permission.buildAccountRecords }}</el-button
                    >
                    <el-button size="small" icon="el-icon-document-copy" class="search-btn btn-primary" @click="combineRecords()" v-if="permission.combineRecords">{{
                        permission.combineRecords
                    }}</el-button>
                    <el-button size="small" icon="el-icon-document-copy" class="search-btn btn-primary" @click="applyAdvancePayment()" v-if="permission.advanceRecords">{{
                        permission.advanceRecords
                    }}</el-button>
                    <div v-if="printList.length > 0" style="margin-left: 6px; margin-right: 6px">
                        <el-button v-if="permission.print && !isDefaultSet" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{
                            permission.print
                        }}</el-button>
                        <el-button
                            v-if="permission.printPreview && !isDefaultSet"
                            size="small"
                            icon="el-icon-view"
                            class="search-btn btn-primary"
                            @click="printPreview()"
                            >{{ permission.printPreview }}</el-button
                        >
                        <el-button
                            v-if="(permission.printPreview || permission.print) && isDefaultSet"
                            size="small"
                            icon="el-icon-printer"
                            class="search-btn btn-primary"
                            @click="printPreview()"
                            >打印</el-button
                        >
                    </div>
                    <div v-else style="margin-left: 6px; margin-right: 6px">
                        <el-button v-if="permission.print && !isDefaultSet" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="askPrintList()">{{
                            permission.print
                        }}</el-button>
                        <el-button
                            v-if="permission.printPreview && !isDefaultSet"
                            size="small"
                            icon="el-icon-view"
                            class="search-btn btn-primary"
                            @click="askPrintListPreview()"
                            >{{ permission.printPreview }}</el-button
                        >
                        <el-button
                            v-if="(permission.printPreview || permission.print) && isDefaultSet"
                            size="small"
                            icon="el-icon-printer"
                            class="search-btn btn-primary"
                            @click="askPrintListPreview()"
                            >打印</el-button
                        >
                    </div>
                    <el-button size="small" type="warning" class="search-btn" @click="gotoInRecords()" v-if="permission.inRecords">{{ permission.inRecords }}</el-button>
                    <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportForm">
                        <i class="fa fa-file-excel-o"></i>
                        {{ permission.export }}</el-button
                    >
                </div>
                <div class="search-ctn-right">
                    <div class="section-summary">
                        <div>
                            <span>{{ summaryStr ? summaryStr : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="receivable-table-ctn">
                <el-table
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="tableData"
                    height="350"
                    ref="multipleTable"
                    :row-class-name="tableRowClassName"
                    @row-click="rowClick"
                    :row-key="getRowKeys"
                    v-el-table-infinite-scroll="tableLoad"
                    empty-text="暂无未结数据"
                    @sort-change="sortChange"
                >
                    <el-table-column sortable="custom" show-overflow-tooltip width="120" prop="Tags" label="供应商标签"></el-table-column>
                    <el-table-column show-overflow-tooltip width="220" prop="EntpCusName" label="供应商"></el-table-column>
                    <el-table-column show-overflow-tooltip v-for="item in payWayList" width="100" :key="item.Value" :label="item.Text">
                        <template slot-scope="scope">
                            {{ payTypeAmout(item.Value, scope.row.UnpaidList) }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="120" prop="RSumPayable" sortable="custom" label="欠款总额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120" prop="AdvanceMoney" label="预付款余额"></el-table-column>
                    <el-table-column show-overflow-tooltip width="180" prop="ApplyTime" label="最近一次确认时间"></el-table-column>
                </el-table>
            </div>
            <div class="section-title">
                <div>
                    <span>确认的单据{{ applyTableDataLength > 0 ? '（共' + applyTableDataLength + '条）' : '' }}</span>
                    <el-button
                        v-if="applyTableDataLength > 0 && applyTableDataLength > searchData2.Limit"
                        size="small"
                        type="primary"
                        class="loadall-btn"
                        @click="loadAllData()"
                        >加载全部数据</el-button
                    >
                </div>
            </div>
            <div class="receivable-table-ctn">
                <el-table
                    v-loading="aLoading"
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="applyTableData"
                    height="350"
                    ref="multipleTable2"
                    :row-key="getOrderRowKeys"
                    @row-click="applyRowClick"
                    @selection-change="handleSelectionChange"
                    :default-sort="{ prop: 'ConfirmTime', order: 'descending' }"
                    v-el-table-infinite-scroll="orderLoad"
                >
                    <el-table-column type="selection" width="50" reserve-selection :selectable="selectInit"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120px" prop="OrgName" label="部门"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110px" prop="ConfirmTime" label="确认时间" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip width="110px" v-if="showSubmitTime" prop="SubmitTime" label="提交时间" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip width="110px" v-if="showCreateTime" prop="CreateTime" label="创建时间" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip width="210px" prop="OrderCode" label="单号">
                        <template slot-scope="scope">
                            <div style="display: flex; flex-direction: row">
                                <i v-if="scope.row.OrderId"
                                    ><el-link
                                        :underline="false"
                                        :href="
                                            scope.row.OrderType == 0
                                                ? '/#/purchaseManage/purchaseOrders/check?id=' + scope.row.OrderId
                                                : '/#/purchaseManage/purchasesReturns/edit_v2?type=1&PReturnId=' + scope.row.OrderId
                                        "
                                        target="_blank"
                                        >{{ scope.row.OrderCode }}</el-link
                                    ></i
                                >
                                <i v-else>{{ scope.row.OrderCode }}</i>
                                <img
                                    v-show="scope.row.OrderId"
                                    src="@/assets/images/preview.png"
                                    title="打印预览"
                                    style="margin-left: 5px; width: 24px; height: 24px"
                                    @click.stop="viewOrderDetail(scope.row.OrderType, scope.row.OrderId, scope.row.OrderCode)"
                                />
                                <img
                                    v-show="scope.row.PRType == 11"
                                    src="@/assets/images/view.png"
                                    title="查看合并明细"
                                    style="margin-left: 5px; margin-top: 5px; width: 24px; height: 13px"
                                    @click.stop="viewCombineDetail(scope.row)"
                                />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="OrderType" label="单据类型">
                        <template slot-scope="scope">
                            <i v-if="scope.row.OrderType == 0" class="c-active">采购付款</i>
                            <i v-else-if="scope.row.OrderType == 1" class="out-active">采购退货</i>
                            <i v-else-if="scope.row.OrderType == 2">合并帐</i>
                            <i v-else>建账</i>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="PayTypeName" label="支付方式"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="TotalAmount" label="欠款总额">
                        <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="AlreadyPaid" label="已付总额">
                        <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.AlreadyPaid : -scope.row.AlreadyPaid }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" label="欠款余额">
                        <template slot-scope="scope">{{
                            scope.row.OrderType != 1
                                ? (scope.row.TotalAmount - scope.row.AlreadyPaid).toFixed(2)
                                : -(scope.row.TotalAmount - scope.row.AlreadyPaid).toFixed(2)
                        }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                    <el-table-column show-overflow-tooltip width="75px" prop="SName" label="开单人"></el-table-column>
                    <el-table-column show-overflow-tooltip width="75px" prop="Confirmer" label="确认人"></el-table-column>
                </el-table>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="单据搜索"
                :visible.sync="dialogVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="85px">
                        <el-form-item label="供应商">
                            <el-select
                                ref="search_0"
                                class="search-item"
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Keyword"
                                remote
                                filterable
                                allow-create
                                clearable
                                placeholder="请输入供应商名称"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="供应商标签">
                            <el-select
                                style="width: 100%"
                                class="search-item"
                                size="small"
                                filterable
                                clearable
                                v-model="searchData.Tags"
                                @visible-change="tagVisibleChange($event)"
                            >
                                <el-option v-for="optionItem in tagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="支付方式">
                            <el-select style="width: 100%" class="search-item" size="small" filterable clearable multiple v-model="searchPayType">
                                <el-option v-for="optionItem in sreachPayWayList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="欠款总额">
                            <div class="flex">
                                <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                    <el-option key=">=" label=">=" value=">="></el-option>
                                    <el-option key=">" label=">" value=">"></el-option>
                                    <el-option key="<=" label="<=" value="<="></el-option>
                                    <el-option key="<" label="<" value="<"></el-option>
                                    <el-option key="=" label="=" value="="></el-option>
                                    <el-option key="!=" label="!=" value="!="></el-option>
                                    <el-option key="between" label="区间" value="between"></el-option>
                                </el-select>
                                <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Amount1"></el-input>
                                <el-input
                                    class="search-item"
                                    size="small"
                                    style="width: 90px"
                                    v-model.trim="searchData.Amount2"
                                    v-if="searchData.Symbol == 'between'"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="预付款余额">
                            <div class="flex">
                                <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol2" clearable placeholder="符号">
                                    <el-option key=">=" label=">=" value=">="></el-option>
                                    <el-option key=">" label=">" value=">"></el-option>
                                    <el-option key="<=" label="<=" value="<="></el-option>
                                    <el-option key="<" label="<" value="<"></el-option>
                                    <el-option key="=" label="=" value="="></el-option>
                                    <el-option key="!=" label="!=" value="!="></el-option>
                                    <el-option key="between" label="区间" value="between"></el-option>
                                </el-select>
                                <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Amount3"></el-input>
                                <el-input
                                    class="search-item"
                                    size="small"
                                    style="width: 90px"
                                    v-model.trim="searchData.Amount4"
                                    v-if="searchData.Symbol == 'between'"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <div style="border-top: 1px dashed #cccccc; height: 1px; overflow: hidden; margin-top: 10px; margin-bottom: 10px"></div>
                        <el-form-item label="部门">
                            <el-select
                                size="small"
                                class="search-item"
                                style="width: 100%"
                                v-model="searchData2.OrgId"
                                filterable
                                clearable
                                collapse-tags
                                reserve-keyword
                                @visible-change="orgVisibleChange($event)"
                                placeholder="请选择"
                            >
                                <el-option v-for="item in orgSearchData" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="确认日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime2"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate2TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '】付欠款' : '付欠款'"
                :visible.sync="isShowApplyDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="1000px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -600px"
            >
                <div v-if="isShowApplyDialog" class="settle-op-content">
                    <ApplyPayment ref="applyPayment" @closeDialog="closeDialog" :ApplyList="multipleSelection"></ApplyPayment>
                </div>
            </el-dialog>
            <!--  打印  -->
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printDialogVisible" width="870px">
                <div class="dialog-content" v-if="printDialogVisible">
                    <printSupPayable
                        @closeDialog="closePrintDialog"
                        :ordersList="printList"
                        :isDefaultSet="isDefaultSet"
                        :isPreview="isPreview"
                        :isInit="true"
                    ></printSupPayable>
                </div>
            </el-dialog>
            <!-- 打印隐藏内容，用于直接打印 -->
            <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important">
                <printSupPayable
                    ref="printDom"
                    @closeDialog="closePrintDialog"
                    :ordersList="printList"
                    :isDefaultSet="isDefaultSet"
                    :isPreview="isPreview"
                    :isInit="false"
                ></printSupPayable>
            </div>
            <!--  打印列表弹窗 -->
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printListDialogVisible" width="870px">
                <div class="dialog-content" v-if="printListDialogVisible">
                    <printSupPayableList
                        @closeDialog="closePrintDialog"
                        :sParams="searchParams"
                        :isDefaultSet="isDefaultSet"
                        :isPreview="isPreview"
                        :isInit="true"
                    ></printSupPayableList>
                </div>
            </el-dialog>
            <!-- 打印列表隐藏内容，用于直接打印 -->
            <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important">
                <printSupPayableList
                    ref="printListDom"
                    @closeDialog="closePrintDialog"
                    :sParams="searchParams"
                    :isDefaultSet="isDefaultSet"
                    :isPreview="isPreview"
                    :isInit="false"
                ></printSupPayableList>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '】建账' : '建账'"
                :visible.sync="isShowBuildDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="400px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -100px"
            >
                <div v-if="isShowBuildDialog" class="settle-op-content">
                    <BuildAccount ref="buildAccount" @closeDialog="closeBuildDialog" :CurrentData="currentApplyRow" :IsEdit="isEditApply" :CType="1"></BuildAccount>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="申请预付款" :visible.sync="dialogApplyVisible" width="1350px">
                <div class="dialog-content" v-if="dialogApplyVisible">
                    <AdvancePayment ref="advanceReceipt" @closeReceipt="closeApplyDialog" :EntpCusId="EntpCusId" :EntpCusName="EntpCusName"></AdvancePayment>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printOrderPreview" width="870px">
                <div class="dialog-content" v-if="printOrderPreview">
                    <printContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :canPrint="true" :isInit="true"></printContent>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printReturnPreview" width="870px">
                <div class="dialog-content" v-if="printReturnPreview">
                    <printReturnContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :isInit="true"></printReturnContent>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '】合并账明细' : '合并账明细'"
                :visible.sync="isShowCombineDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="1000px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -600px"
            >
                <div v-if="isShowCombineDialog" class="settle-op-content">
                    <CombineRAndP ref="applyReceipt" @closeDialog="closeDialog" :CombineList="multipleSelection"></CombineRAndP>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="合并记录" :visible.sync="dialogComRecordsVisible" width="1000px">
                <div class="dialog-content" v-if="dialogComRecordsVisible">
                    <CombineRecords ref="combineRecords" @closeRecords="closeComRecords" :EntpCusId="EntpCusId" :EntpCusName="EntpCusName"></CombineRecords>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                append-to-body
                :title="'【' + EntpCusName + '】' + comCode + ' 合并明细'"
                :visible.sync="dialogDetailVisible"
                width="900px"
            >
                <div class="dialog-content" v-if="dialogDetailVisible">
                    <CombineDetails @closeDetails="closeDetailDialog" :RecordId="recordId"></CombineDetails>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="建账记录" :visible.sync="dialogBuildAccountVisible" width="1200px">
                <div class="dialog-content" v-if="dialogBuildAccountVisible">
                    <BuildAccountRecords
                        ref="combineRecords"
                        @closeRecords="closeComRecords"
                        :EntpCusId="EntpCusId"
                        :Permission="permission"
                        :EntpCusName="EntpCusName"
                    ></BuildAccountRecords>
                </div>
            </el-dialog>
            <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
            <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
                <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
                <span>您也可以打开新的窗口进行其他的操作</span>
            </div>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import ApplyPayment from '@/components/business/revenue_h/applyPayment';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
import printSupPayable from '@/components/printModels/printSupPayable';
import printSupPayableList from '@/components/printModels/printSupPayableList';
import BuildAccount from '@/components/business/revenue_h/buildAccount';
import AdvancePayment from '@/components/business/supplierManage/advancePayment';
import CombineRAndP from '@/components/business/revenue_h/combineSupRAndP';
import CombineRecords from '@/components/business/supplierManage/combineRecords';
import CombineDetails from '@/components/business/supplierManage/combineDetails';
import BuildAccountRecords from '@/components/business/supplierManage/buildAccountRecords';
export default {
    mixins: [],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        ApplyPayment,
        printSupPayable,
        printSupPayableList,
        BuildAccount,
        AdvancePayment,
        CombineRAndP,
        CombineRecords,
        CombineDetails,
        BuildAccountRecords
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                });
            }
        },
        tableData() {
            if (this.payWayList.length == 0) {
                this.getPay().then(() => {
                    if (this.searchPayType.length > 0) {
                        this.payWayList = this.sreachPayWayList.filter(x => this.searchPayType.some(one => one == x.Value));
                    } else {
                        this.payWayList = this.sreachPayWayList;
                    }
                    this.doLayout();
                });
            } else this.doLayout();
        }
    },
    data() {
        return {
            dialogDetailVisible: false,
            dialogComRecordsVisible: false,
            isShowCombineDialog: false,
            dialogBuildAccountVisible: false,
            comCode: '',
            recordId: '',
            datetime1: [],
            datetime2: [],
            EntpCusId: '',
            EntpCusName: '',
            summaryStr: '',
            loading: false,
            hLoading: false,
            aLoading: false,
            isStopReq: false,
            cusName: '',
            isEditApply: false,
            multipleSelection: null,
            printDialogVisible: false,
            printListDialogVisible: false,
            dialogVisible: false,
            isShowApplyDialog: false,
            isShowBuildDialog: false,
            dialogApplyVisible: false,
            scanData: '',
            dataindex: -1,
            stopFresh: true,
            stopOrderFresh: false,
            isShowSummary: false,
            tagsList: [],
            isStartSearch: false,
            searchData: {
                Tags: '',
                Keyword: '',
                Symbol: '',
                Amount1: 0,
                Amount2: 0,
                Symbol2: '',
                Amount3: 0,
                Amount4: 0,
                SortProp: '',
                SortType: '',
                PayType: [],
                Page: 1,
                Limit: 25
            },
            searchData2: {
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CusId: '',
                OrgId: '',
                Page: 1,
                Limit: 15
            },
            searchParams: {},
            currentRow: {},
            currentApplyRow: {},
            tableData: [],
            applyTableData: [],
            orderGoodsData: [],
            tableDataLength: 0,
            permission: {},
            cusId: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            printList: [],
            isDefaultSet: true, //是否使用浏览器的打印功能
            isPreview: false, //是否出现预览界面
            printOrderPreview: false,
            printReturnPreview: false,
            idList: [],
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            showSubmitTime: false,
            showCreateTime: false,
            payWayList: [],
            sreachPayWayList: [],
            searchPayType: [],
            applyTableDataLength: 0,
            orgSearchData: []
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        // this.getPay();
    },
    mounted() {
        this.permission = this.$util.getPermission('SupPayable_H');
        this.getConfigByCodes().then(() => {
            this.getPay().then(data => {
                this.getTableData();
            });
        });

        this.getPrintComponents();
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        getPay() {
            return new Promise(resolve => {
                this.$util.getPay().then(data => {
                    this.payWayList = data.filter(x => x.IsSpecial);
                    this.sreachPayWayList = data.filter(x => x.IsSpecial);
                    resolve(data);
                });
            });
        },
        payTypeAmout(value, list) {
            if (value) {
                var amount = 0;
                if (list != null && list.length > 0) {
                    var plist = list.filter(x => x.PayType == value);
                    plist.forEach(x => {
                        amount += x.Unpaid;
                    });
                }
                return amount.toFixed(2);
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['syllqdysz', 'dyyl', 'zkglzstjsj', 'zkglzscjsj'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                                case 'dyyl': //是否出现预览界面
                                    this.isPreview = result;
                                    break;
                                case 'zkglzstjsj': //显示提交时间
                                    this.showSubmitTime = result;
                                    break;
                                case 'zkglzscjsj': //显示创建时间
                                    this.showCreateTime = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        handleKeyEvent(e) {
            if (this.printDialogVisible || this.printListDialogVisible) return;
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            if (key === 13) {
                if (that.dialogVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                } else if (that.isShowApplyDialog) {
                    if (that.$refs.applyPayment) {
                        that.$refs.applyPayment.submitForm();
                    }
                }
            }
            if (key === 27) {
                if (that.dialogVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                } else if (that.isShowApplyDialog) that.isShowApplyDialog = false;
            }
            //下键
            if (key == 40) {
                e.preventDefault();
                if (that.dataindex != that.tableDataLength - 1) {
                    that.$refs.multipleTable2.clearSelection();
                    if (that.currentRow && that.currentRow.EntpCusId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getApplyTableData();
                        }
                    });
                }
            }
            //上键
            if (key == 38) {
                e.preventDefault();
                if (that.dataindex != 0) {
                    that.$refs.multipleTable2.clearSelection();
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getApplyTableData();
                        }
                    });
                }
            }
        },
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.Page += 1;
                else this.searchData.Page = 1;
                this.getTableData();
            }
        },
        orderLoad() {
            if (!this.stopOrderFresh) {
                if (this.applyTableData && this.applyTableData.length > 0) {
                    this.searchData2.Page += 1;
                    this.getApplyTableData();
                }
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            let that = this;
            that.$refs.multipleTable2.clearSelection();
            that.dataindex = row.index;
            that.currentApplyRow = {};
            that.currentRow = row;

            if (that.currentRow && that.currentRow.EntpCusId && (that.searchData2.CusId != that.currentRow.EntpCusId || that.applyTableData.length == 0)) {
                that.searchData2.Page = 1;
                that.searchData2.Limit = 15;
                that.applyTableData = [];
                that.getApplyTableData();
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = [];
            this.printList = [];
            if (val.length > 0) {
                this.isShowSummary = true;
                let sa = 0; //销售总额
                let yshj = 0; //应收合计
                let sqhj = 0; //已申请合计
                let firstCus = '';
                for (let i = 0; i < val.length; i++) {
                    if (!val[i].IsCanStateBack) {
                        let oa = 0;
                        let ss = 0;
                        if (i == 0) {
                            firstCus = val[i].EntpCusId;
                            this.multipleSelection.push(val[i]);

                            oa = val[i].SumPayable;
                            ss = val[i].TotalAmount;
                        } else {
                            if (firstCus !== val[i].EntpCusId) {
                                this.$refs.multipleTable2.toggleRowSelection(val[i], false);
                            } else {
                                this.multipleSelection.push(val[i]);
                                oa = val[i].SumPayable;
                                ss = val[i].TotalAmount;
                            }
                        }

                        if (val[i].OrderType == 0) {
                            sa += oa;
                            yshj += ss;
                            if (val[i].IsCanStateBack) sqhj += ss;
                        } else {
                            sa -= oa;
                            yshj -= ss;
                            if (val[i].IsCanStateBack) sqhj -= ss;
                        }
                    }
                    val[i].EntpCusName = this.currentRow.EntpCusName;
                    this.printList.push(val[i]);
                }
            }
        },
        resetSearch() {
            this.searchData = {
                Tags: '',
                Keyword: '',
                Symbol: '',
                Amount1: 0,
                Amount2: 0,
                Symbol2: '',
                Amount3: 0,
                Amount4: 0,
                SortProp: '',
                SortType: '',
                PayType: [],
                Page: 1,
                Limit: 25
            };
            this.searchPayType = [];
            this.searchData2 = {
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CusId: '',
                OrgId: '',
                Page: 1,
                Limit: 15
            };
            this.datetime1 = [];
            this.datetime2 = [];
            this.searchCustom('');
            this.$refs.multipleTable2.clearSelection();
        },
        getTableData() {
            let that = this;
            if (!that.isStopReq) {
                if (that.searchData.Symbol) {
                    if (that.searchData.Symbol == 'between') {
                        if (isNaN(parseInt(that.searchData.Amount1))) {
                            that.$util.warningMsg('请输入正确的金额');
                            return;
                        }
                        if (isNaN(parseInt(that.searchData.Amount2))) {
                            that.$util.warningMsg('请输入正确的金额');
                            return;
                        }
                    } else {
                        if (isNaN(parseInt(that.searchData.Amount1))) {
                            that.$util.warningMsg('请输入正确的金额');
                            return;
                        }
                    }
                } else {
                    that.searchData.Amount1 = 0;
                    that.searchData.Amount2 = 0;
                }
                if (that.searchData.Symbol2) {
                    if (that.searchData.Symbol == 'between') {
                        if (isNaN(parseInt(that.searchData.Amount3))) {
                            that.$util.warningMsg('请输入正确的预付款余额');
                            return;
                        }
                        if (isNaN(parseInt(that.searchData.Amount4))) {
                            that.$util.warningMsg('请输入正确的预付款余额');
                            return;
                        }
                    } else {
                        if (isNaN(parseInt(that.searchData.Amount3))) {
                            that.$util.warningMsg('请输入正确的预付款余额');
                            return;
                        }
                    }
                } else {
                    that.searchData.Amount3 = 0;
                    that.searchData.Amount4 = 0;
                }

                that.payWayList = [];
                if (that.searchPayType.length > 0) {
                    that.searchData.PayType = that.searchPayType;
                } else {
                    that.payWayList = that.sreachPayWayList;
                }

                if (that.searchData.Page == 1) {
                    that.searchParams = { ...that.searchData };
                    that.tableData = [];
                    that.tableDataLength = 0;
                    that.summaryStr = '';
                    that.applyTableData = [];
                } else {
                    that.searchParams.Page = that.searchData.Page;
                }
                that.stopFresh = true;
                that.hLoading = true;
                that.isStopReq = true;
                that.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_H/GetSupItemizedSummary',
                        data: that.searchParams,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (res.errcode != 201) {
                            if (data) {
                                if (that.searchData.Page == 1) {
                                    that.tableData = [];
                                    that.tableDataLength = res.count;
                                    that.summaryStr = data.SummaryStr;
                                    that.applyTableData = [];
                                    if (that.searchPayType.length > 0) {
                                        that.payWayList = that.sreachPayWayList.filter(x => that.searchPayType.some(one => one == x.Value));
                                    } else {
                                        that.payWayList = that.sreachPayWayList;
                                    }
                                }
                                let list = [...that.tableData, ...data.DataList];
                                that.tableData = list;
                                that.stopFresh = data.DataList.length < that.searchData.Limit;
                            }
                        } else {
                            that.stopFresh = that.tableData.length >= that.tableDataLength;
                        }
                    })
                    .catch(() => {
                        that.isStopReq = false;
                        that.hLoading = false;
                    })
                    .finally(() => {
                        that.isStopReq = false;
                        that.hLoading = false;
                    });
            }
        },
        getApplyTableData() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpCusId) that.aLoading = true;
            that.searchData2.CusId = that.currentRow.EntpCusId;

            if (that.searchData2.CusId) {
                that.stopOrderFresh = true;
                that.$util
                    .axiosGet({
                        url: '/api/RevenueManagement_H/GetSupOrdersAppliesList',
                        data: that.searchData2,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        that.aLoading = false;
                        if (res.errcode != 201) {
                            if (!data) {
                                if (that.searchData2.Page == 1) {
                                    that.applyTableDataLength = 0;
                                    that.applyTableData = [];
                                }
                                return;
                            } else {
                                if (that.searchData2.Page == 1) {
                                    that.applyTableDataLength = res.count;
                                    that.applyTableData = [];
                                }
                            }

                            let list = [...that.applyTableData, ...data];
                            that.applyTableData = list;

                            that.stopOrderFresh = that.applyTableData.length >= that.applyTableDataLength;
                        } else {
                            that.stopOrderFresh = that.applyTableData.length >= that.applyTableDataLength;
                        }
                    })
                    .catch(() => {
                        that.aLoading = false;
                    });
            }
        },
        handleSearch() {
            let that = this;
            if (that.$refs.multipleTable2) that.$refs.multipleTable2.clearSelection();
            if (
                that.applyTableData &&
                ((that.searchData2.StartDate && that.searchData2.EndDate) || (that.searchData2.UStartDate && that.searchData2.UEndDate) || that.searchData2.OrgId)
            ) {
                // if (that.searchData2.StartDate && that.searchData2.EndDate) {
                //     that.applyTableData = that.applyTableData.filter(f => {
                //         let data1 = new Date(f.CreateTime);
                //         let data2 = new Date(that.$util.formatDateV3(that.searchData2.StartDate));
                //         let data3 = new Date(that.$util.formatDateV3(that.searchData2.EndDate));
                //         return data1 >= data2 && data1 <= data3;
                //     });
                // }
                // if (this.searchData2.UStartDate && this.searchData2.UEndDate) {
                //     this.applyTableData = this.applyTableData.filter(f => {
                //         let data1 = new Date(f.ConfirmTime);
                //         let data2 = new Date(that.$util.formatDateV3(that.searchData2.UStartDate));
                //         let data3 = new Date(that.$util.formatDateV3(that.searchData2.UEndDate));
                //         return data1 >= data2 && data1 <= data3;
                //     });
                // }
                that.applyTableData = [];
                that.searchData2.Page = 1;
                that.getApplyTableData();
            } else {
                that.dataindex = 0;
                that.searchData.Page = 1;
                that.getTableData();
            }
        },
        batchComfirms() {
            let that = this;
            if (that.multipleSelection && that.multipleSelection.length > 0) {
                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowApplyDialog = true;
            } else {
                that.$util.warningMsg('请先勾选需要收款的项');
            }
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusId;
        },
        getOrderRowKeys(row) {
            return row.RecordId;
        },
        closeDialog(isEdit) {
            this.isShowApplyDialog = false;
            this.isShowCombineDialog = false;
            let that = this;
            if (isEdit) {
                that.multipleSelection = null;
                that.searchData.Page = 1;
                that.tableData = [];
                that.applyTableData = [];
                that.resetSearch();
                that.getTableData();
            }
        },
        selectInit(row, index) {
            //如果没有选中，要开放全部选择
            if (row.IsCanStateBack) return false;
            if (this.multipleSelection && this.multipleSelection.length > 0) {
                if (this.cusId && this.cusId.length > 0) {
                    if (row.EntpCusId == this.cusId[0] && !row.IsCanStateBack) {
                        return true;
                    } else {
                        return false;
                    }
                } else return true;
            } else return true; //可勾选
        },
        gotoSettle(item) {
            if (item.SettleCode) {
                this.$router.push('/financeManage/settlements/customers?code=' + item.SettleCode);
            }
        },
        searchTags() {
            let url = '/api/EntpSuppliers/GetEnterpriseSupplierTagList';
            this.loading = true;
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true
                })
                .then(res => {
                    this.tagsList = res.data;
                });
        },
        tagVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.tagsList.length == 0) that.searchTags();
            }
        },
        // 打印预览
        printPreview() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }

            if (this.printList.length == 0) {
                this.$util.warningMsg('请选择单打印');
                return;
            }
            this.printDialogVisible = true;
        },
        print() {
            if (this.printList.length == 0) {
                this.$util.warningMsg('请选择单打印');
                return;
            }
            this.$refs.printDom.init(true);
        },
        askPrintListPreview() {
            let that = this;
            this.$util.elConfirm({
                content: '当前未勾选单据明细，是否打印筛选的应付汇总表？',
                noMsg: true,
                confirm() {
                    that.printListDialogVisible = true;
                }
            });
        },
        askPrintList() {
            let that = this;
            this.$util.elConfirm({
                content: '当前未勾选单据明细，是否打印筛选的应付汇总表？',
                noMsg: true,
                confirm() {
                    that.$refs.printListDom.init(true);
                }
            });
        },
        closePrintDialog() {
            this.printDialogVisible = false;
            this.printListDialogVisible = false;
        },
        showBuildAccount(isEdit) {
            this.isShowBuildDialog = true;
            this.isEditApply = false;
            if (isEdit) this.isEditApply = isEdit;

            if (this.currentRow && this.currentRow.EntpCusId) {
                this.currentApplyRow.EntpCusId = this.currentRow.EntpCusId;
                this.currentApplyRow.EntpCusName = this.currentRow.EntpCusName;
            }
        },
        closeBuildDialog(isEdit) {
            this.isShowBuildDialog = false;
            this.isEditApply = false;
            if (isEdit) {
                this.$refs.multipleTable2.clearSelection();
                this.multipleSelection = null;
                this.searchData.Page = 1;
                this.tableData = [];
                this.applyTableData = [];
                this.getTableData();
            }
        },
        applyRowClick(row, column, event) {
            this.currentApplyRow = row;
        },
        buildAccountRecords() {
            if (this.currentRow) {
                this.EntpCusId = this.currentRow.EntpCusId;
                this.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusId = '';
                this.EntpCusName = '';
            }
            this.dialogBuildAccountVisible = true;
        },
        delAccount() {
            let that = this;
            if (that.currentApplyRow && that.currentApplyRow.RecordId && (that.currentApplyRow.PRType == 10 || that.currentApplyRow.PRType == 5)) {
                that.$confirm('您确定要删除该账款吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.aLoading = true;
                        that.$util
                            .axiosPost({
                                url: `/api/RevenueManagement_H/DelAccountRecords?recordId=${that.currentApplyRow.RecordId}`,
                                hideLoading: true
                            })
                            .then(res => {
                                that.$util.successMsg('删除成功');
                                if (that.applyTableData.length == 1) {
                                    that.$refs.multipleTable2.clearSelection();
                                    that.multipleSelection = null;
                                    that.searchData.Page = 1;
                                    that.tableData = [];
                                    that.applyTableData = [];
                                    that.getTableData();
                                } else
                                    for (let index = 0; index < that.applyTableData.length; index++) {
                                        if (that.applyTableData[index].RecordId == that.currentApplyRow.RecordId) {
                                            that.applyTableData.splice(index, 1);
                                            return;
                                        }
                                    }
                            })
                            .catch(() => {})
                            .finally(() => {
                                this.aLoading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请刷新后重新操作');
            }
        },
        applyAdvancePayment(item) {
            if (item) {
                this.EntpCusId = item.EntpCusId;
                this.EntpCusName = item.EntpCusName;
            } else {
                this.EntpCusId = '';
                this.EntpCusName = '';
            }
            this.dialogApplyVisible = true;
        },
        closeApplyDialog() {
            this.dialogApplyVisible = false;
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData2.StartDate = val[0];
                this.searchData2.EndDate = val[1];
            } else {
                this.searchData2.StartDate = '';
                this.searchData2.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData2.UStartDate = val[0];
                this.searchData2.UEndDate = val[1];
            } else {
                this.searchData2.UStartDate = '';
                this.searchData2.UEndDate = '';
            }
        },
        viewOrderDetail(orderType, orderId, orderCode) {
            if (orderId) {
                if (orderType == 0) {
                    this.idList.push({
                        id: orderId,
                        orderCode: orderCode
                    });
                    this.printOrderPreview = true;
                } else if (orderType == 1) {
                    this.idList.push({
                        PReturnId: orderId
                    });
                    this.printReturnPreview = true;
                }
            } else {
                this.$util.warningMsg('要打印的订单异常，请刷新后重新操作');
            }
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents(1).then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printPurchases'));
                }
            });

            that.$util.getPrintComponents(5).then(data => {
                if (data) {
                    Vue.component('printReturnContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printReturnContent', () => import('@/components/printModels/printPurReturn'));
                }
            });
        },
        closeOrderPrintDialog() {
            this.printOrderPreview = false;
            this.printReturnPreview = false;
            this.idList = [];
        },
        gotoInRecords() {
            this.$router.push(`/financeManage/inRecords`);
        },
        // 导出
        exportForm() {
            let that = this;
            if (that.printList.length > 0) {
                this.$util.elConfirm({
                    content: '确定导出供应商明细表吗？',
                    noMsg: true,
                    confirm() {
                        let EntpCusName = that.printList[0].EntpCusName;
                        that.$util.exportFile_post({
                            url: '/api/RevenueManagement_H/ExportSupOrdersAppliesList',
                            data: {
                                EntpCusName: EntpCusName,
                                ExportList: that.printList
                            }
                        });
                    }
                });
            } else {
                that.$confirm('未选择导出明细，是否导出供应商汇总表？如果数据过多可能耗时稍长', '提醒', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        that.exportData();
                    })
                    .catch(() => {
                        return;
                    });
            }
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选数据');
                return;
            }
            that.saveLoading = true;
            let saveLimit = 100;
            if (that.tableDataLength < saveLimit) saveLimit = that.tableDataLength;

            let reqData = { ...that.searchData };
            reqData.Limit = saveLimit;
            reqData.Page = that.currtPage;

            that.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetSupItemizedSummaryToExport',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    that.saveCount += saveLimit;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.tableDataLength);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.tableDataLength <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile({
                                url: '/api/RevenueManagement_H/ExportSupItemizedSummary'
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            });
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.saveLoading = false;
                });
        },
        combineComfirms() {
            let that = this;
            if (that.multipleSelection && that.multipleSelection.length > 1) {
                let os2 = that.multipleSelection.filter(f => f.PRType == 11);
                if (os2 && os2.length > 1) {
                    that.$util.warningMsg('合并帐明细中不可以包含两条合并帐条目');
                    return;
                }

                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowCombineDialog = true;
            } else {
                that.$util.warningMsg('请先勾选需要的合并项，需要勾选两条或两条以上进行合并');
            }
        },
        combineRecords() {
            if (this.currentRow) {
                this.EntpCusId = this.currentRow.EntpCusId;
                this.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusId = '';
                this.EntpCusName = '';
            }
            this.dialogComRecordsVisible = true;
        },
        viewCombineDetail(item) {
            if (this.currentRow) {
                this.EntpCusName = this.currentRow.EntpCusName;
            } else {
                this.EntpCusName = '';
            }
            this.recordId = item.RecordId;
            this.comCode = item.OrderCode;
            this.dialogDetailVisible = true;
        },
        closeComRecords() {
            if (this.dialogComRecordsVisible) this.dialogComRecordsVisible = false;
            if (this.dialogBuildAccountVisible) this.dialogBuildAccountVisible = false;
        },
        closeDetailDialog(isEdit) {
            if (isEdit) {
                if (this.currentRow) {
                    this.getApplyTableData();
                }
            }
            this.dialogDetailVisible = false;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.Page = 1;
            this.getTableData();
        },
        doLayout() {
            this.$nextTick(() => {
                this.$refs.multipleTable.doLayout();
                this.$refs.multipleTable2.doLayout();
            });
        },
        loadAllData() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpCusId) that.aLoading = true;
            that.searchData2.CusId = that.currentRow.EntpCusId;
            that.searchData2.Page = 1;
            that.searchData2.Limit = that.applyTableDataLength;

            if (that.searchData2.CusId) {
                that.stopOrderFresh = true;
                that.$util
                    .axiosGet({
                        url: '/api/RevenueManagement_H/GetSupOrdersAppliesList',
                        data: that.searchData2,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        that.aLoading = false;
                        if (res.errcode != 201) {
                            if (!data) {
                                if (that.searchData2.Page == 1) {
                                    that.applyTableDataLength = 0;
                                    that.applyTableData = [];
                                }
                                return;
                            } else {
                                if (that.searchData2.Page == 1) {
                                    that.applyTableDataLength = res.count;
                                    that.applyTableData = [];
                                }
                            }

                            let list = [...that.applyTableData, ...data];
                            that.applyTableData = list;

                            that.stopOrderFresh = that.applyTableData.length >= that.applyTableDataLength;
                        } else {
                            that.stopOrderFresh = that.applyTableData.length >= that.applyTableDataLength;
                        }
                    })
                    .catch(() => {
                        that.aLoading = false;
                    });
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
#search-dc-dialog,
#apply-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
#apply-dialog::-webkit-scrollbar {
    display: none;
}
.v-content {
    width: 100%;
    height: calc(100vh);
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 65vh;
    left: 60vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}

.loadall-btn {
    margin-top: 4px;
    height: 24px;
    // width: 25px;
    line-height: 24px;
    padding: 0 5px;
    margin-right: 5px;
    margin-left: 10px;
}
</style>
<style lang="less">
.receivable-table-ctn {
    .el-link {
        justify-content: flex-start;
    }
    .el-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 4px 0;
                }
            }
        }
        th {
            padding: 4px 0;
        }
        margin-bottom: 10px;
    }
    .el-table__footer {
        td {
            padding: 4px 0;
        }
    }
}
</style>
